import ArrowDownward from '@mui/icons-material/ArrowDownward'
import { Box, Button, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useGetMentions } from '@omnea-app/fe-comments/useGetMentions'
import { StatusDot } from '@omnea-app/omui/StatusDot'

export const MOBILE_MENTIONS_SECTION_ID = 'mobile-mentions-section'

export const ScrollToMentionsBanner = () => {
  const { t } = useTranslation('dashboard')
  const { data: unresolvedMentionsData } = useGetMentions({ isResolved: false })
  const unresolvedMentionsCount = unresolvedMentionsData?.mentions?.length ?? 0

  const handleClick = () => {
    document.getElementById(MOBILE_MENTIONS_SECTION_ID)?.scrollIntoView({ behavior: 'smooth' })
  }

  if (unresolvedMentionsCount === 0) return null

  return (
    <Button
      onClick={handleClick}
      fullWidth
      sx={{
        px: 4,
        py: 3,
        backgroundColor: 'bg.surface.subtle',
        border: 'stroke.default',
        borderColor: 'border.subtle',
        borderRadius: 2,
        textTransform: 'none',
        gap: 2,
        '&:hover': {
          bgcolor: 'bg.interactive.hover',
        },
        mb: 3,
      }}
    >
      <StatusDot size={8} color="brand" />
      <Typography variant="body-medium">{t('mentions.unresolved-mentions', { count: unresolvedMentionsCount })}</Typography>

      <Box sx={{ flexGrow: 1 }} />

      <ArrowDownward sx={{ color: 'fg.subtle' }} />
    </Button>
  )
}
